<template>
  <a-modal v-model:visible="visible"
           :title="$t('CustomSpus.ShoppingCartModal.addToCart')"
           :cancel-button-props="{ style: { display: 'none' } }"
           :ok-text="$t('CustomSpus.ShoppingCartModal.addToCart')"
           :destroy-on-close="true"
           :body-style="{ padding: '24px' }"
           @ok="onAdd"
           @cancel="onReset">
    <AddToCart ref="addToCart" />
  </a-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { CartData } from '../../types'
import AddToCart from './AddToCart.vue'

const visible = ref(false)

const addToCart = ref<any>()

const show = () => {
  visible.value = true
}

const hide = () => {
  visible.value = false
}

const setProduct = (product: CartData) => {
  if (addToCart.value) {
    addToCart.value.reset()
    addToCart.value.setProduct(product)
  }
}

defineExpose({
  show,
  hide,
  setProduct
})

const onAdd = () => {
  if (addToCart.value) {
    addToCart.value.addProduct().then(() => {
      addToCart.value.reset()
      visible.value = false
    }).catch(() => { })
  }
}

const onReset = () => {
  if (addToCart.value) {
    addToCart.value.reset()
  }
}

</script>
<style scoped lang="less">
</style>
